import React from "react";
import FacebookLogin from "@greatsumini/react-facebook-login";
import "./style.scss";
import facebook from "@assets/images/logo/facebook.png";
interface FacebookLoginComponentProps {
  appId?: string;
  onSuccess: (response: any) => void;
  onFailed: (error: any) => void;
  extraClassName?: string;
}

const FacebookLoginComponent: React.FC<FacebookLoginComponentProps> = ({
  appId = import.meta.env.VITE_FACEBOOK_CLIENT_ID as string,
  onSuccess,
  onFailed,
  extraClassName,
}) => {
  return (
    <FacebookLogin
      appId={appId}
      onSuccess={(response: any) => onSuccess(response)}
      onFail={(error: any) => onFailed(error)}
      useRedirect={false}
      render={({ onClick }) => (
        <button onClick={onClick} className={`fb-login-button ${extraClassName || ""}`}>
          <img src={facebook} width={18} alt="Facebook Logo" className="facebook-icon" />
          <span>Continue with Facebook</span>
        </button>
      )}
    />
  );
};

export default FacebookLoginComponent;
